




























































import Vue from 'vue';
import Button from '../components/common/Button/Button.vue';

import axios from 'axios';

/**
 * DEMO용 더미 계정 정보
 */
const demoUser = {
  userEmail: 'demo@aiqa.com',
  userPwd: 'F7hbrSZF',
};

export default Vue.extend({
  components: {
    Button,
  },
  data(): {
    resourceServerStatus: 'loading' | 'bad' | 'good';
    authServerStatus: 'loading' | 'bad' | 'good';
  } {
    return {
      resourceServerStatus: 'loading',
      authServerStatus: 'loading',
    };
  },
  created() {
    // 백엔드 서버 상태 확인
    this.getResourceServerStatus().then((status) => {
      this.resourceServerStatus = status ? 'good' : 'bad';
    });
    this.getAuthServerStatus().then((status) => {
      this.authServerStatus = status ? 'good' : 'bad';
    });
  },
  computed: {
    backendOK(): boolean {
      return (
        this.resourceServerStatus === 'good' && this.authServerStatus === 'good'
      );
    },
  },
  methods: {
    /**
     *
     */
    enter: function () {
      if (this.backendOK) this.$router.push('/home');
    },
    /**
     * 리소스 서버의 상태 확인 (리소스 서버의 api 페이지를 요청했을 때 정상적으로 응답하는가)
     */
    getResourceServerStatus: async function () {
      try {
        return (await axios.get('/api', { timeout: 10000 })).status === 200;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    /**
     * 데모용 인증 서버의 상태 확인 (내장된 계정 정보를 제출했을 때 201 상태를 반환하는가)
     */
    getAuthServerStatus: async function () {
      try {
        return (
          (
            await axios.post(
              '/userapi/v1/login',
              {
                user_email: demoUser.userEmail,
                user_password: demoUser.userPwd,
              },
              { timeout: 10000 },
            )
          ).status === 201
        );
      } catch (error) {
        console.error(error);
        return false;
      }
    },
  },
});
